import type { CanvasElement } from '@/components/canvas/document/publicTypes';
import { type BaseElementConfig, createBase } from '../registry/factoryShared';

export function createGroupElement(
  config: BaseElementConfig & { children: string[] },
): CanvasElement<'group'> {
  return {
    ...createBase('group', config),
    data: { children: config.children },
  };
}
